import { SizeGauge } from '@modules/NewMaker/UI/sizeGauge/SizeGauge.ts';
import { html, strMap } from 'fxjs/es';
import { ButtonCTA } from '@modules/NewMaker/UI/ButtonCTA/ButtonsCTA.ts';

const offsetOptionHtml = (offset_options, selected_offset_option_id) => {
  return html`
    <div class="sizegauge__offset_options">
      <div class="sizegauge__offset_options__name">${offset_options.option_name}</div>
      ${strMap((o) => {
        const selected = selected_offset_option_id
          ? selected_offset_option_id == o.id
          : offset_options.default_bp_option_id == o.id;
        return new ButtonCTA({
          theme: 'outline',
          text: o['name' + G._en],
          size: 'm',
          klass: 'sizegauge__offset_options__option',
          selected,
          id: o.id,
        }).toHtmlSSR();
      }, offset_options.bp_options)}
    </div>
  `;
};

export const sizegauge = (data) => {
  return html`<div class="sizegauge">
    ${new SizeGauge(data).toHtmlSSR()}
    ${offsetOptionHtml(data.offset_options, data.selected_offset_option_id)}
  </div> `;
};
